let AP: any = null;
// simple-xdm relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') {
	// unable to evaluate fg('platform_deprecate_lp_cc_embed') at the module level and using uniqueKey query param (which is feature gated) instead
	let hasUniqueKey = false;
	if (typeof window !== 'undefined') {
		try {
			hasUniqueKey = new URL(window.location.href).searchParams.has('uniqueKey');
		} catch (e) {
			hasUniqueKey = false;
		}
	}
	AP = hasUniqueKey
		? require('@atlassian/simple-xdm/dist/iframe')
		: require('simple-xdm/dist/iframe');
}

import { EP_REACT_PROPS_OBSERVABLE_OBJECT, ObservableObject } from '../observable-object';

import {
	PASSTHROUGH_PROPS_MODULE_NAME,
	type PassThroughPropsModule,
	PROPS_UPDATED,
} from './channel';
import type { IframePassThroughProps } from './IframeElementType';
import { requireModule } from './requireModule';

/**
 * Entry point method will be used within confluence-frontend iframe to subscribe to parent window's events
 * In parent window, the module will be set up as example:
 *
 * host.defineModule(PASSTHROUGH_PROPS.name, {
 *     getPassThroughProps: () => { // function to dispatch and send the props },
 *     navigationPolicyNavigate: () => { // function to execute navigationPolicy.navigate in parent window},
 * });
 *
 */
export const subscribeCrossDomainCommunication = () => {
	if (!AP) {
		return;
	}

	let uniqueKey = null;
	try {
		uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
	} catch (e) {
		uniqueKey = null;
	}

	const module = requireModule<PassThroughPropsModule>(
		uniqueKey ? `${PASSTHROUGH_PROPS_MODULE_NAME}_${uniqueKey}` : PASSTHROUGH_PROPS_MODULE_NAME,
	);

	if (!module) {
		return;
	}

	const observableObject = new ObservableObject<IframePassThroughProps>();
	// @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
	window[EP_REACT_PROPS_OBSERVABLE_OBJECT] = observableObject;

	let props: IframePassThroughProps | undefined;

	AP.register({
		// Subcribe to "propsUpdated" event from parent window
		// Once received and parsed data, set the object as value for Observable
		// Subsequent "propsUpdated" event will trigger subscribers set up by `useReactProps`
		[PROPS_UPDATED]: ({ message }: { message: string }) => {
			try {
				props = JSON.parse(message);
			} catch (e) {
				props = undefined;
			}

			if (props) {
				observableObject.object = {
					...props,
					navigationPolicy: {
						...props?.navigationPolicy,
						// Delegate the handling of navigationPolicy.navigate to defined module method in parent window
						navigate: module.navigationPolicyNavigate,
					},
					onPublish: module.onPublish,
				};
			}
		},
	});

	//Trigger the command to get passthrough props from parent window
	module.getProps();
};
